import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";
import { BannerOption } from "../types/event";

// S2 endpoint — banner list
const BANNER_END_POINT = "event/admin/banners/";

/**
 * The fixed banner library, from S2.
 *
 * `{id, img}` per entry, which is NOT the shape the chosen banner is stored in
 * — see `BannerOption`. Reversed because the endpoint answers oldest first and
 * the newest banners are the ones anyone is looking for.
 */
export function useBanner() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data: banners = [], isPending } = useQuery<BannerOption[]>({
		queryKey: ["banners"],
		queryFn: async () => {
			const res = await callPymbleApi(instance, "GET", BANNER_END_POINT);
			return res ? [...(res as BannerOption[])].reverse() : [];
		},
		enabled: isAuthenticated,
	});

	return {
		banners,
		bannersLoaded: !isPending,
	};
}
